import { useQuery } from '@tanstack/react-query';

import { readUnreadNotificationCount } from '@/lib/api/generated/api';

import { notificationKeys } from '../queryKeys';

/**
 * Unread notifications across every workspace (spec 131 US1).
 *
 * Kept fresh by the stream (`useNotificationStream` writes the count each
 * message carries), by window focus, and by the mark-read responses, which
 * return the new count. No interval: the constitution's Server State
 * Freshness rule, now that a push channel exists.
 */
export function useUnreadCount(): number | undefined {
  const query = useQuery({
    queryKey: notificationKeys.count(),
    queryFn: async () => {
      const response = await readUnreadNotificationCount();
      if (response.status !== 200) throw new Error('unread count unavailable');
      return response.data.unread;
    },
    refetchOnWindowFocus: 'always',
    retry: false,
  });
  return query.data;
}
